module.exports = __webpack_public_path__ + "static/img/biaoxianjiyin.0310bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serverImg/biaoxianjiyin.png
// module id = E7JF
// module chunks = 41